import { Link } from 'react-router-dom';

/** Lost Grove wordmark (owned asset) paired with the "Pick 'Em" product name. */
export function Wordmark({
  to = '/',
  className = '',
  showTag = true,
}: {
  to?: string;
  className?: string;
  showTag?: boolean;
}) {
  return (
    <Link to={to} className={`flex items-center gap-3 ${className}`} aria-label="Lost Grove Pick 'Em home">
      <img
        src="/brand/logo.png"
        alt="Lost Grove Brewing"
        className="h-9 w-auto"
        width={382}
        height={152}
      />
      {showTag && (
        <span className="font-display text-2xl uppercase tracking-wide text-amber leading-none">
          Pick&nbsp;’Em
        </span>
      )}
    </Link>
  );
}

/** Small grove emblem badge for accents (uses the brand favicon SVG). */
export function GroveMark({ className = 'h-6 w-6' }: { className?: string }) {
  return <img src="/brand/favicon.svg" alt="" aria-hidden className={className} />;
}
